import { render } from "./leads-details.vue?vue&type=template&id=f6139692&scoped=true"
import script from "./leads-details.vue?vue&type=script&lang=js"
export * from "./leads-details.vue?vue&type=script&lang=js"

import "./leads-details.vue?vue&type=style&index=0&id=f6139692&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6139692"]])

export default __exports__